"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var subregionPagePath = function subregionPagePath(_id, slug) {
  return "/surf-forecasts/" + slug + "/" + _id;
};

exports.default = subregionPagePath;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/subregionPagePath.js
// module id = 709
// module chunks = 11